import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/manage-badges',
		name: 'ManageBadges',
		component: () => import(/* webpackChunkName: "ManageBadges" */ '../views/ManageBadges.vue'),
	},
	{
		path: '/send-access',
		name: 'SendAccess',
		component: () => import(/* webpackChunkName: "SendAccessSMS" */ '../views/SendAccessSMS.vue'),
	},
	{
		path: '/manage-menus',
		name: 'ManageMenus',
		component: () => import(/* webpackChunkName: "ManageMenus" */ '../views/ManageMenus.vue'),

	},
	{
		path: '/launch',
		name: 'Launch',
		component: () => import(/* webpackChunkName: "launch" */ '../views/Launch.vue'),
	},
	// {
	// 	path: '/active',
	// 	name: 'Active',
	// 	component: () => import(/* webpackChunkName: "active" */ '../views/Active.vue'),
	// },
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
